module.exports = __webpack_public_path__ + "img/georgievsk.436906f2.jpeg";